import axios from 'axios';
import { toast } from 'react-toastify';
import { getLocalStorage } from '../../../utils/web-storage';
// Action Types
export const GET_ANALYTICS_STATS_START = 'GET_ANALYTICS_STATS_START';
export const GET_ANALYTICS_STATS_SUCCESS = 'GET_ANALYTICS_STATS_SUCCESS';
export const GET_ANALYTICS_STATS_ERROR = 'GET_ANALYTICS_STATS_ERROR';
const serverUrl = process.env.REACT_APP_PARTPLAY_SERVICE_URL;
// Action Creator
export const getAnalyticsStats = () => async (dispatch) => {
  try {
    dispatch({
      type: GET_ANALYTICS_STATS_START,
    });

    // Get token from localStorage directly
    const accessToken = getLocalStorage('accessToken');

    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    // Use relative URL - React will proxy to backend
    const response = await axios.get(serverUrl + '/stats', config);

    dispatch({
      type: GET_ANALYTICS_STATS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    toast.error(error.message || 'Unable to fetch analytics stats');
    dispatch({
      type: GET_ANALYTICS_STATS_ERROR,
    });
  }
};
